<div class="report-info-wrapper">
    <div class="filter-settings-wrapper">
        @switch (filterFormAPI().periodDefinitionType) {
            @case (periodType.InMarket) {
                <span class="subtitle">I markedet i perioden</span>
            }
            @case (periodType.Registered) {
                <span class="subtitle">Registrert i perioden</span>
            }
            @case (periodType.Sold) {
                <span class="subtitle">Solgt i perioden</span>
            }
            @default {
                <span class="subtitle">Statistikk</span>
            }
        }
        <div class="range">
            <subscription-range-infographics
                [fromDate]="filterFormAPI().fromDate"
                [toDate]="filterFormAPI().toDate"
                [saleSelection]="filterFormAPI().periodDefinitionType"
                [smallMode]="true"
            ></subscription-range-infographics>
        </div>
        <div class="row bold">Utvalg</div>
        @if (!filterFormAPI().areas?.length && !filterFormAPI().geoBorder?.length) {
            <div class="row">Kartutsnitt</div>
        } @else {
            <subscription-selection></subscription-selection>
        }
        <div class="row space"></div>
        <div class="row">
            Rapporten viser
            {{ getReportDescription() }}
        </div>

        <div class="row bold">Boligtyper</div>
        <div class="estate-types">
            <div class="icons">
                @if (containsEstateType(EVEstateType.Enebolig)) {
                    <div class="estate-row">
                        <div class="symbol enebolig"></div>
                        <div>Enebolig</div>
                    </div>
                }
                @if (containsEstateType(EVEstateType.Tomannsbolig)) {
                    <div class="estate-row">
                        <div class="symbol tomannsbolig"></div>
                        <div>Tomannsbolig</div>
                    </div>
                }
                @if (containsEstateType(EVEstateType.Rekkehus)) {
                    <div class="estate-row">
                        <div class="symbol rekkehus"></div>
                        <div>Rekkehus</div>
                    </div>
                }
                @if (containsEstateType(EVEstateType.Leilighet)) {
                    <div class="estate-row">
                        <div class="symbol leilighet"></div>
                        <div>Leilighet</div>
                    </div>
                }
                @if (containsEstateType(EVEstateType.Fritidsbolig)) {
                    <div class="estate-row">
                        <div class="symbol fritidsbolig"></div>
                        <div>Fritidsbolig</div>
                    </div>
                }
                @if (containsEstateType(EVEstateType.Annet)) {
                    <div class="estate-row">
                        <div class="symbol annet"></div>
                        <div>Andre</div>
                    </div>
                }
            </div>
        </div>
        <div class="row space"></div>
        <div>
            <subscription-filter-keyvalue
                text="Byggeår"
                [valueFrom]="filterFormAPI().buildYearFrom?.toString()"
                [valueTo]="filterFormAPI().buildYearTo?.toString()"
            ></subscription-filter-keyvalue>

            <subscription-filter-keyvalue
                text="Areal"
                [valueFrom]="filterFormAPI().unitAreaFrom?.toString()"
                [valueTo]="filterFormAPI().unitAreaTo?.toString()"
                annotation="m²"
            ></subscription-filter-keyvalue>
            <subscription-filter-keyvalue
                text="Tomtestørrelse"
                [valueFrom]="filterFormAPI().plotAreaFrom?.toString()"
                [valueTo]="filterFormAPI().plotAreaTo?.toString()"
                annotation="m²"
                [thousandize]="true"
            ></subscription-filter-keyvalue>
            <subscription-filter-keyvalue
                text="Etasje"
                [valueFrom]="filterFormAPI().floorNumberFrom?.toString()"
                [valueTo]="filterFormAPI().floorNumberTo?.toString()"
            ></subscription-filter-keyvalue>
            <subscription-filter-keyvalue
                text="Rom"
                [valueFrom]="filterFormAPI().numberOfBedroomFrom?.toString()"
                [valueTo]="filterFormAPI().numberOfBedroomTo?.toString()"
            ></subscription-filter-keyvalue>
            <subscription-filter-keyvalue
                text="Pris"
                [valueFrom]="filterFormAPI().priceFrom?.toString()"
                [valueTo]="filterFormAPI().priceTo?.toString()"
                annotation=",- "
                [thousandize]="true"
            ></subscription-filter-keyvalue>
            <subscription-filter-keyvalue
                text="m²-pris"
                [valueFrom]="filterFormAPI().sqmPriceFrom?.toString()"
                [valueTo]="filterFormAPI().sqmPriceTo?.toString()"
                annotation=",- "
                [thousandize]="true"
            ></subscription-filter-keyvalue>
            <subscription-filter-keyvalue
                text="Omsetningstid"
                [valueFrom]="filterFormAPI().timeOnMarketFrom?.toString()"
                [valueTo]="filterFormAPI().timeOnMarketTo?.toString()"
                annotation=",- "
                [thousandize]="true"
            ></subscription-filter-keyvalue>
        </div>
        @if (filterFormAPI().isGreenHome) {
            <div class="row row__block">
                <div>Grønn bolig&nbsp;</div>
                <div class="row__column-right">
                    {{ greenHousingString() }}
                </div>
            </div>
        }
        @if (filterFormAPI().energyLabels?.length) {
            <div class="row row__block">
                <div>Energimerker&nbsp;</div>
                <div class="row__column-right">{{ filterFormAPI().energyLabels.join(", ") }}</div>
            </div>
        }
        @if (facilitiesString().length > 0) {
            <div class="row row__block">
                <div>Fasiliteter&nbsp;</div>
                <div class="row__column-right">
                    {{ facilitiesString() }}
                </div>
            </div>
        }
        <div class="row row__block">
            <div>Eieform bolig&nbsp;</div>
            <div class="row__column-right">{{ ownershipString() }}</div>
        </div>
        <div class="row row__block">
            <div>Eieform tomt&nbsp;</div>
            <div class="row__column-right">{{ plotOwnershipString() }}</div>
        </div>
    </div>
</div>
